// extracted by mini-css-extract-plugin
export var carrierTab = "_3p-0";
export var carrierTabActive = "_3p-1 _3p-0";
export var carrierTabInactive = "_3p-2 _3p-0";
export var carrierTabLabel = "_3p-3";
export var carrierTabLabelActive = "_3p-4 _3p-3";
export var carrierTabLabelInactive = "_3p-5 _3p-3";
export var carrierTabPercentage = "_3p-6";
export var carrierTabPercentageActive = "_3p-7 _3p-6";
export var carrierTabPercentageInactive = "_3p-8 _3p-6";
export var carrierTabWinnable = "_3p-9";
export var carrierTabWinnableActive = "_3p-a _3p-9";
export var carrierTabWinnableInactive = "_3p-b _3p-9";
export var comparisonContainer = "_3p-d";
export var missingRateButton = "_3p-n";
export var missingRateButtonActive = "_3p-o _3p-n";
export var missingRateButtonInactive = "_3p-p _3p-n";
export var missingRateButtonLabel = "_3p-q";
export var missingRateButtonLabelActive = "_3p-r _3p-q";
export var missingRateButtonLabelInactive = "_3p-s _3p-q";
export var sidebar = "_3p-c";
export var strategyButton = "_3p-e";
export var strategyButtonActive = "_3p-f _3p-e";
export var strategyButtonDescription = "_3p-k";
export var strategyButtonDescriptionActive = "_3p-l _3p-k";
export var strategyButtonDescriptionInactive = "_3p-m _3p-k";
export var strategyButtonInactive = "_3p-g _3p-e";
export var strategyButtonLabel = "_3p-h";
export var strategyButtonLabelActive = "_3p-i _3p-h";
export var strategyButtonLabelInactive = "_3p-j _3p-h";
export var unitToggleButton = "_3p-t";
export var unitToggleButtonActive = "_3p-u _3p-t";
export var unitToggleButtonInactive = "_3p-v _3p-t";
export var unitToggleButtonLabel = "_3p-w";
export var unitToggleButtonLabelActive = "_3p-x _3p-w";
export var unitToggleButtonLabelInactive = "_3p-y _3p-w";